// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-radio-button__inner {\n    border-radius: 20px !important;\n    border: 1px solid #dcdfe6 !important;\n    box-shadow: none !important;\n    padding: 8px 20px;\n}\n.list-inline li {\n    margin-right: 30px;\n}\n  \n", ""]);
// Exports
module.exports = exports;
